import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import { ReferralRequestorDispatchTypes } from "../../../models/DispatchTypes/ReferralRequest";
import { ReferralRequestor } from "../../../models/ReferralRequestor";
import { saveReferralRequestor } from "../../../actions/ReferralRequest";
import RequestorInformation from "../components";

const mapStateToProps = ({ referralRequestorState }: ApplicationState) => ({
    referralRequestor: referralRequestorState,
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<
        ApplicationState,
        Record<string, never>,
        ReferralRequestorDispatchTypes
    >
) => {
    return {
        saveReferralRequestor: (sessionData: ReferralRequestor) => {
            dispatch(saveReferralRequestor(sessionData));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestorInformation);
